<template>
    <div>
        <el-card class="box-card">
            <el-tabs v-model="activeName">
                <el-tab-pane  label="审核任务" name="first">
                    <div>
                    <el-row :gutter="20">
                        <el-col :span="24" >
                            <el-card class="box-card"  shadow="never" style="margin-bottom:5px;">
                                <div style="margin-bottom:-11px">
                                    <b style="font-size:14px;line-height:33px">今日审核错误数量 
                                      <el-tag type="danger" size="mini"  effect="dark">{{ todayErrorNum }}</el-tag>
                                       <template v-if="todayErrorNum==0">
                                           请继续保持，无任何错误将获得奖励
                                       </template>
                                       <template v-else>
                                           请认证核对，审核错误将有一定处罚
                                       </template>
                                 </b>
                                <span style="float:right">
                                    <b style="font-size:14px;line-height:33px">进行中总单数：</b>
                                    <el-tag size="mini"  effect="dark">{{processNum}}
                                     </el-tag>
                                   <!-- <b style="font-size:14px;line-height:33px">待审核</b>
                                   <el-tag size="mini" type="danger"   effect="dark">{{waitNum}}</el-tag> -->
                                    <el-checkbox style="margin-left:20px" v-model="isReview">只看待审</el-checkbox>
                                    <el-checkbox style="margin-left:-10px" v-model="autoFush">自动刷新</el-checkbox>
                                    <el-button style="margin-left:20px"    size="mini" @click="query" icon="el-icon-refresh" type="primary">刷新</el-button>
                                </span>
                                </div>
                            </el-card>
                            <el-card class="box-card">
                                <el-table
                                v-loading="isLoading"
                                :data="tableData"
                                :height="bodyHeight-80"
                                style="width: 100%">
                                <el-table-column
                                        width="100px"
                                            label="明细Id">
                                            <template slot-scope="scope">
                                                <el-link target="_blank"  type="info">{{scope.row.DetailId}}</el-link>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                        width="240px"
                                            label="工单编号">
                                            <template slot-scope="scope">
                                                <el-link target="_blank" icon="el-icon-c-scale-to-original"  type="primary">{{scope.row.Code}}</el-link>
                                                 <el-tag size="mini" v-if="scope.row.IsRefundOrder" style="margin-left:10px" effect="dark">退款单 </el-tag>
                                            </template>
                                    </el-table-column>
                                     <el-table-column
                                        label="店铺名称">
                                        <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                            <span v-if="scope.row.ShopType==1" >
                                                <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                                    {{scope.row.ShopName}}
                                                    </div>
                                            </span>
                                            <span v-else-if="scope.row.ShopType==2" >
                                                <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                                    {{scope.row.ShopName}}
                                                </div>
                                            </span>
                                            <span  v-else>
                                                <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                                    {{scope.row.ShopName}}
                                                </div>
                                            </span>
                                        </el-tooltip>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="Spec"
                                            label="规格">
                                    </el-table-column>
                                    <el-table-column
                                            width="100px"
                                            label="商品单价">
                                            <template slot-scope="scope">
                                                <el-link type="danger">￥{{scope.row.Price.toFixed(2)}}</el-link>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="80px"
                                            label="购买数量">
                                            <template slot-scope="scope">
                                                 <el-tag size="mini" type="" effect="dark">{{scope.row.BuyNum}}</el-tag>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="100px"
                                            label="垫付本金">
                                            <template slot-scope="scope">
                                                <el-link type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="120"
                                            prop="AliTrademanager"
                                            label="买手账号">
                                    </el-table-column>
                                    <el-table-column
                                        width="120"
                                            prop="Phone"
                                            label="买手手机号">
                                    </el-table-column>
                                    <el-table-column
                                        width="180"
                                        label="接单时间">
                                        <template slot-scope="scope">
                                            <el-link  icon="el-icon-date" type="primary">{{scope.row.OrderTime}}</el-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="80"
                                        label="状态">
                                            <template  slot-scope="scope">
                                                <el-tooltip v-if="scope.row.Status==12" class="item" effect="dark" :content="scope.row.CancelReason" placement="bottom">
                                                    <el-tag effect="dark"  type="danger" size="mini">已取消</el-tag>
                                                </el-tooltip>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==0" size="mini" >待确认</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==1" size="mini" >搜索</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==2" size="mini" >货比</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==3" size="mini" >找到商品</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==4" size="mini" >浏览详情</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==5" size="mini" >收藏关注</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==6" size="mini" >选择规格</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==7" size="mini" >提交订单</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus<3" size="mini" >订单审核</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus==3" size="mini" >已打款</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==9" size="mini" >完成支付</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==10" size="mini" >付款审核</el-tag>
                                                <el-tag effect="dark" style="cursor:pointer" @click="undo(scope.row)" type="success" v-else-if="scope.row.Status==11" size="mini" >已完成</el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column 
                                        label="操作"
                                        width="100px" >
                                        <template slot-scope="scope">
                                            <el-tooltip  v-if="scope.row.Status==10" class="item" effect="dark" content="任务完成" placement="bottom">
                                                <el-button  size="mini" type="success" @click="pass(scope.row)" icon="el-icon-check" circle></el-button>
                                            </el-tooltip>
                                            <el-tooltip  v-if="scope.row.Status==10" class="item" effect="dark" content="不通过，不通过之后将会回到上一步" placement="bottom">
                                                <el-button  size="mini" type="danger" @click="over(scope.row)" icon="el-icon-close" circle></el-button>
                                            </el-tooltip>
                                        </template>
                                        </el-table-column>
                                </el-table>
                            </el-card>
                        </el-col>
                    </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="历史记录" name="second">
                    <div>
                        <el-card class="box-card"  shadow="never" style="margin-bottom:5px;line-height:22px;">
                            <div style="margin-bottom:-11px">
                                 <b style="font-size:14px;">日期范围内错误： 
                                <el-tag type="danger" size="mini"  effect="dark">{{ rangeErrorNum }}</el-tag>
                            </b>
                            <span>
                                <el-input
                                size="small"
                                style="width:350px;margin-left:20px"
                                placeholder="用户手机号/任务编号/订单编号/买手账号/店铺名称"
                                prefix-icon="el-icon-search"
                                v-model="queryModel.queryTxt">
                                </el-input>
                                <el-date-picker
                                :clearable="false"
                                size="small" 
                                style="width:250px;margin-left:20px"
                                v-model="queryModel.times"
                                type="daterange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                                </el-date-picker>
                                <el-checkbox style="margin-left:20px" v-model="queryModel.onlyError">只看错误</el-checkbox>
                                <el-tooltip class="item" effect="dark" content="查询" placement="top">
                                    <el-button type="primary" size="small" style="margin-left:15px;" @click="queryRecord" icon="el-icon-search" plain circle></el-button>
                                </el-tooltip>
                                
                            </span>
                            <el-pagination
                            style="float:right"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryModel.pIndex"
                            :page-sizes="[20, 40, 60, 80]"
                            :page-size="queryModel.pSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                            </el-pagination>
                            </div>
                        </el-card>
                        <el-card class="box-card">
                                <el-table
                                v-loading="isLoadingRecord"
                                :data="recordData"
                                :height="bodyHeight-80"
                                style="width: 100%">
                                    <el-table-column
                                        width="100px"
                                            label="明细Id">
                                            <template slot-scope="scope">
                                                <el-link target="_blank"   type="info">{{scope.row.DetailId}}</el-link>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                        width="180px"
                                            label="工单编号">
                                            <template slot-scope="scope">
                                                <el-link target="_blank" icon="el-icon-c-scale-to-original"  type="primary">{{scope.row.Code}}</el-link>
                                            </template>
                                    </el-table-column>
                                     <el-table-column
                                        label="店铺名称">
                                        <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                            <span v-if="scope.row.ShopType==1" >
                                                <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                                    {{scope.row.ShopName}}
                                                    </div>
                                            </span>
                                            <span v-else-if="scope.row.ShopType==2" >
                                                <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                                    {{scope.row.ShopName}}
                                                </div>
                                            </span>
                                            <span  v-else>
                                                <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                                    {{scope.row.ShopName}}
                                                </div>
                                            </span>
                                        </el-tooltip>
                                        </template>
                                    </el-table-column>
                                     <el-table-column
                                     width="180px"
                                            prop="OrderCode"
                                            label="订单编号">
                                    </el-table-column>
                                    <el-table-column
                                            prop="Spec"
                                            label="规格">
                                    </el-table-column>
                                    <el-table-column
                                            width="100px"
                                            label="商品单价">
                                            <template slot-scope="scope">
                                                <el-link type="danger">￥{{scope.row.Price.toFixed(2)}}</el-link>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="80px"
                                            label="购买数量">
                                            <template slot-scope="scope">
                                                 <el-tag size="mini" type="" effect="dark">{{scope.row.BuyNum}}</el-tag>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="100px"
                                            label="垫付本金">
                                            <template slot-scope="scope">
                                                <el-link type="danger" >￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                            </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="120"
                                            prop="AliTrademanager"
                                            label="买手账号">
                                    </el-table-column>
                                    <el-table-column
                                        width="120"
                                            prop="Phone"
                                            label="买手手机号">
                                    </el-table-column>
                                    <el-table-column
                                        width="180"
                                        label="接单时间">
                                        <template slot-scope="scope">
                                            <el-link  icon="el-icon-date" type="primary">{{scope.row.OrderTime}}</el-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    width="80"
                                        label="状态">
                                            <template  slot-scope="scope">
                                                <el-tooltip v-if="scope.row.Status==12" class="item" effect="dark" :content="scope.row.CancelReason" placement="bottom">
                                                    <el-tag effect="dark"  type="danger" size="mini">已取消</el-tag>
                                                </el-tooltip>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==0" size="mini" >待确认</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==1" size="mini" >搜索</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==2" size="mini" >货比</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==3" size="mini" >找到商品</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==4" size="mini" >浏览详情</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==5" size="mini" >收藏关注</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==6" size="mini" >选择规格</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==7" size="mini" >提交订单</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus<3" size="mini" >订单审核</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus==3" size="mini" >已打款</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==9" size="mini" >完成支付</el-tag>
                                                <el-tag effect="dark" v-else-if="scope.row.Status==10" size="mini" >付款审核</el-tag>
                                                <el-tag effect="dark" style="cursor:pointer" @click="showImg(scope.row.ReviewImg)" type="success" v-else-if="scope.row.Status==11" size="mini" >已完成</el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column 
                                        label="审单错误"
                                        width="100px" >
                                        <template slot-scope="scope">
                                            <el-tooltip class="item" effect="dark" v-if="scope.row.Abnormal" :content="scope.row.Abnormal" placement="left">
                                                <el-tag  type="danger" effect="dark" size="mini"> 有错误</el-tag>
                                            </el-tooltip>
                                            
                                            <el-tag v-else type="success" effect="dark" size="mini"> 无错误</el-tag>
                                        </template>
                                        </el-table-column>
                                </el-table>
                            </el-card>
                    </div>
                </el-tab-pane>
             </el-tabs>
        </el-card>
        <el-drawer
        :modal="false"
        style="z-index:9999"
        title="任务审核"
        :visible.sync="overVisible">
            <el-form  style="padding:20px" :model="overModel"  :rules="orverRules" ref="overForm" label-width="170px">
                <el-form-item label="店铺：" >
                                            <span v-if="setRow.ShopType==1" >
                                                <div style="margin-left:5px;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                                    {{setRow.ShopName}}
                                                    </div>
                                            </span>
                                            <span v-else-if="setRow.ShopType==2" >
                                                <div style="margin-left:5px;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                                    {{setRow.ShopName}}
                                                </div>
                                            </span>
                                            <span  v-else>
                                                <div style="margin-left:5px;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                                    {{setRow.ShopName}}
                                                </div>
                                            </span>
                </el-form-item>
                <el-form-item label="规格&单价&购买数量：">
                     <el-tag size="mini" >{{setRow.Spec}}</el-tag>
                     <el-tag size="mini" type="danger" effect="dark"  style="margin-left:20px">￥{{setRow.Price}}</el-tag>
                     <el-tag size="mini" effect="plain"  style="margin-left:20px">× {{setRow.BuyNum}}</el-tag>
                </el-form-item>

                <el-form-item label="买手提交订单号：" prop="orderCode">
                    <el-input  placeholder="请输入买手提交订单号" v-model="overModel.orderCode"></el-input>
                </el-form-item>
                <el-form-item label="买手阿里旺旺：" prop="aliTrademanager">
                    <el-input placeholder="请输入买手阿里旺旺" v-model="overModel.aliTrademanager"></el-input>
                </el-form-item>
                <el-form-item label="买手实际垫付金额：" prop="advanceMoney">
                    <el-input :disabled="setRow.IsRefundOrder" placeholder="请输入买手实际垫付金额" v-model="overModel.advanceMoney"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align:center">
                <el-button @click="overVisible = false">取 消</el-button>
                <el-button :loading="isLoadingPass" type="primary" @click="submitOver">确 定</el-button>
            </div>
                        
        </el-drawer>

                <el-image-viewer 
                style="z-index:999;text-align:left"
                v-if="overVisible"  
                :url-list="[setRow.ReviewImg]" />
                
                <el-image-viewer 
                style="z-index:999;text-align:left"
                 :on-close="closeImg" 
                v-if="imageVisible"  
                :url-list="[img]" />
    </div>
</template>
<script>
const validateAcquaintance = (rule, value, callback) => {
  if (value < 1 || value > 200000) {
    callback(new Error('金额必须在 1 至 200000 之间'))
  } else {
    callback()
  }
}
import {orderGetOk,orderGet,billHeartbeat,orderGetTodayErrorNum,orderOver,orderPass} from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'App',
  components: {
      ElImageViewer
  },
    props:{
      isOnLine:{
        type:Boolean,
        required: true
      },
      outsider:{
        type:Object,
        required: true
      },
    },
  data() {
    return {
        isLoadingPass:false,
        bodyHeight:0,
         activeName: 'first',
         autoFush:false,
         isReview:false,
         tableData:[],
         isLoading:false,
         isLoadingRecord:false,
         recordData:[],
         showViewer:false,
         img:"",
         todayErrorNum:0,
         timer:{},
         fushTimer:{},
         overVisible:false,
         orverRules: {
            orderCode: [
                { required: true, message: '请填写买手提交订单号：', trigger: 'blur' },
                { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
            ],
            aliTrademanager: [
                { required: true, message: '请填写买手阿里旺旺：', trigger: 'blur' },
                { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
            ],
            advanceMoney: [
                { required: true, message: '请填写买手实际垫付金额：',trigger: 'blur'},
                { validator: validateAcquaintance, trigger: 'blur'}            
            ],
        },
        setRow:{},
        overModel:{
            aliTrademanager:"",
            orderCode:"",
            advanceMoney:0,
            orderId:0,
        },
        rangeErrorNum:0,
        queryModel:{
            queryTxt:"",
            times:[],
            pIndex:1,
            pSize:10,
            onlyError:false,
        },
        total:0,
        processNum:0,
        waitNum:0,
        imageVisible:false,
    };
  },
  watch:{
  },
  created() {
    this.bodyHeight=document.documentElement.clientHeight-220;
  },
      beforeDestroy() {
      clearTimeout(this.timer);
      clearTimeout(this.fushTimer);
    },
  mounted() {
        var date=new Date();
        this.queryModel.times.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.times.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
      this.query();
      this.timer= setInterval(() => {
          if(this.isOnLine){
              billHeartbeat({},()=>{

              });
          }
      }, 10000);
    
      this.fushTimer= setInterval(() => {
          if(this.autoFush){
              this.query();
          }
      }, 10000);
      orderGetTodayErrorNum({},(res)=>{
          this.todayErrorNum=res.Result;
      })
  },
   methods:{
        closeImg(){
            this.imageVisible=false;
        },
       showImg(url){
           this.img=url;
           this.imageVisible=true;
       },
       queryRecord(){
           this.isLoadingRecord=true;
            orderGetOk({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                times:this.queryModel.times==null?"[]":JSON.stringify(this.queryModel.times),
                onlyError:this.queryModel.onlyError
            },(res)=>{
                this.recordData=res.Result.list;
                this.rangeErrorNum=res.Result.errorNum;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoadingRecord=false;
                }, 200);
                
            });
       },
       query(){
           this.isLoading=true;
           orderGet({isReview:this.isReview},(res)=>{
               this.tableData=res.Result;
               this.processNum=this.tableData.length;
               console.log(this.tableData.length);
               setTimeout(() => {
                   this.isLoading=false;
               }, 200);
           })
       },
       over(scope){
            this.$prompt('请输入不通过原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '请输入不通过原因'
            }).then(({ value }) => {
                orderOver({orderId:scope.Id,remark:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.Status=9;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
       },
       pass(scope){
            this.overVisible=true;
            this.overModel.aliTrademanager=scope.AliTrademanager;
            this.overModel.orderCode=scope.OrderCode;
            this.overModel.advanceMoney=scope.AdvanceMoney;
            this.overModel.orderId=scope.Id;
            this.setRow=scope;
        },
        submitOver(){
            this.$refs["overForm"].validate((valid) => {
                if (valid) {
                    this.isLoadingPass=true;
                    orderPass(this.overModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.setRow.Status=res.Result.Status;
                            this.setRow.AliTrademanager=res.Result.AliTrademanager;
                            this.setRow.OrderCode=res.Result.OrderCode;
                            this.setRow.ActualCommission=res.Result.ActualCommission;
                            this.setRow.AdvanceMoney=res.Result.AdvanceMoney;
                            this.overModel={orderCode:"",aliTrademanager:"",advanceMoney:0,orderId:0};
                            this.overVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                        this.isLoadingPass=false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.queryRecord();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.queryRecord();
        }
   },
}
</script>
<style >
.el-card__body{
   padding: 20px; 
   padding-top: 10px;
}
</style>